<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title>
          ESTIMATIVA DE FATURAMENTO - FORNECEDOR
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark color="green darken-3" @click="validate()">
          <v-icon left>mdi-check</v-icon> Salvar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-alert type="success" v-if="successSave">
        <template v-slot:close>
          <v-icon @click="() => (successSave = false)"> mdi-close </v-icon>
        </template>
        Estiamtivas Salvas com Sucesso
      </v-alert>
      <v-form
        ref="form"
        class="compact-form"
        v-model="valid"
        :lazy-validation="lazy"
      >
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12">
              <v-btn
                :disabled="companies.length == 0"
                :href="url_pdf"
                target="_blank"
                color="grey darken-4"
                outlined
                small
                class="mt-1 mr-2"
              >
                <v-icon color="red" left> mdi-file-pdf-box </v-icon>
                PDF
              </v-btn>
              <!-- <v-btn
                :disabled="companies.length == 0"
                @click="exportEstimates('excel')"
                color="grey darken-4"
                outlined
                small
                class="mt-1"
              >
                <v-icon color="green" left> mdi-file-excel-box </v-icon>
                Excel
              </v-btn> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card elevation="0">
                <v-toolbar
                  color="blue darken-4"
                  class="font-weight-bold"
                  dense
                  outlined
                  height="28"
                  dark
                  >Estimativa Fornecedor</v-toolbar
                >
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="500">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left text-no-wrap" width="500">
                                Fornecedor
                              </th>
                              <th class="text-left text-no-wrap" width="100">
                                Tipo
                              </th>
                              <th
                                colspan=""
                                class="text-center text-no-wrap"
                                width="400"
                              >
                                Configuração
                              </th>
                              <!-- <th class="text-left text-no-wrap" width="150">
                                Estimativa Faturamento
                              </th> -->
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="estimate in companies"
                              :key="estimate.company_id"
                            >
                              <td>
                                {{ estimate.company.code }} -
                                {{ estimate.company.name }}
                              </td>
                              <td>
                                <v-select
                                  :items="types"
                                  v-model="estimate.type"
                                  label=""
                                  dense
                                ></v-select>
                              </td>
                              <td class="text-right">
                                <v-row v-if="estimate.type !== 'fixed'">
                                  <v-col cols="12" md="6">
                                    <v-text-field
                                      outlined
                                      dense
                                      label="Data Limite"
                                      hide-details
                                      v-mask="dateMask"
                                      v-model="estimate.date_end"
                                      ref="issue_date"
                                      class="fs-12"
                                      append-outer-icon="mdi-calendar"
                                      @click:append-outer="
                                        handleClickCalendar(
                                          estimate,
                                          'date_end'
                                        )
                                      "
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" md="6">
                                    <v-text-field
                                      outlined
                                      dense
                                      value="0"
                                      class="fs-12"
                                      hide-details
                                      v-model="estimate.days"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row v-else>
                                  <v-col cols="12" md="6">
                                    <v-text-field
                                      outlined
                                      label="Data Fixa"
                                      dense
                                      hide-details
                                      v-mask="dateMask"
                                      v-model="estimate.date_fixed"
                                      ref="fixed_date"
                                      class="fs-12"
                                      append-outer-icon="mdi-calendar"
                                      @click:append-outer="
                                        handleClickCalendar(
                                          estimate,
                                          'date_fixed'
                                        )
                                      "
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </td>
                              <!-- <td class="text-right">
                                <v-text-field
                                  outlined
                                  dense
                                  value="0"
                                  class="fs-12"
                                  hide-details
                                  v-model="estimate.days"
                                ></v-text-field>
                              </td> -->
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      ref="dialog"
      v-model="modalDate"
      :return-value.sync="dateDialog"
      width="290px"
    >
      <v-date-picker
        v-model="dateDialog"
        scrollable
        no-title
        @change="handlePickerDate"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalDate = false"> Fechar </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import AwesomeMask from "awesome-mask";
// import * as CompanyAPI from "@/api/requests/CompanyRequest";
import * as API from "@/api/requests/CompanyHasEstimatedRevenueRequest";

export default {
  components: {},
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    dateMask: "99/99/9999",
    companies: [],
    loading: false,
    successSave: false,
    lazy: false,
    valid: true,
    dateDialog: "",
    modalDate: false,
    fieldEdited: "",
    companyEditDate: {},
    types: [
      { value: "fixed", text: "Data Fixa" },
      { value: "additional", text: "Dias corridos" },
    ],
  }),
  computed: {
    url_pdf: function () {
      return `${URL}company-estimated-revenue/export/pdf`;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.loadCompanies();
    },
    async loadCompanies() {
      this.successSave = false;
      this.companies = [];
      try {
        let response = await API.getAll();
        // let data = await response.json();
        let data = response.estimates;
        console.log(response);
        response.companies.map((item) => {
          if (
            data.find((estimate) => estimate.company_id === item.id) ===
            undefined
          ) {
            data.push({
              days: 60,
              date_end: "",
              company_id: item.id,
              company: item,
              date_fixed: "",
              type: "additional",
            });
          } else {
            let indexEstimate = data.findIndex(
              (estimate) => estimate.company_id === item.id
            );
            if (
              data[indexEstimate].type === "fixed" &&
              data[indexEstimate].date_fixed === null
            ) {
              data[indexEstimate].type = "additional";
              data[indexEstimate].days = "60";
            }
          }
        });
        data = data.map((item) => ({
          ...item,
          date_end: this.dateToBr(item.date_end),
          date_fixed: this.dateToBr(item.date_fixed),
        }));
        this.companies = data.sort((a, b) =>
          a.company.code > b.company.code ? 1 : -1
        );
        console.log(this.companies);
      } catch (error) {
        this.companies = [];
      } finally {
        // this.loading = false;
      }
    },
    getCountCompaniesChecked() {
      return this.companies.filter((i) => i.check != false).length;
    },
    validate() {
      let data = [...this.companies];
      data = data.map((item) => ({
        ...item,
        date_end: this.dateToEua(item.date_end),
        date_fixed: this.dateToEua(item.date_fixed),
      }));
      console.log(data);
      this.post(data);
      // let data = this.companies.map((item) => ({
      //   company_id: item.id,
      //   id: item.indicator_id,
      //   month: this.month,
      //   year: this.year,
      //   pairs: parseInt(item.pairs),
      //   accessories: parseInt(item.accessories),
      //   conservation_products: parseInt(item.conservation_products),
      //   stock: parseInt(item.stock),
      //   billing: item.billing,
      //   national_percent: parseFloat(this.getNationalPercent(item)),
      // }));
      // console.log(data);
      // if (data.length > 0) {
      //   this.post(data);
      // }
    },
    async post(data) {
      this.loading = true;
      this.successSave = false;
      try {
        API.post(data);
        this.successSave = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getTotalSum(field) {
      let total = this.companies.reduce(
        (prev, curr) =>
          prev +
          (!isNaN(parseFloat(curr[field])) ? parseFloat(curr[field]) : 0),
        0
      );
      return field !== "billing" ? parseInt(total) : total.toFixed(2);
    },
    getNationalPercent(company) {
      if (parseFloat(company.billing) === 0.0) {
        return "0.00";
      }
      return parseFloat(
        (company.billing / this.getTotalSum("billing")) * 100
      ).toFixed(2);
    },
    currencyBrToEua(value) {
      return value.toString().replace(/\./gi, "").replace(/,/gi, ".");
    },
    dateToEua(date) {
      if (date == undefined) return "";
      return date.split("/").reverse().join("-");
    },
    dateToBr(date) {
      if (date == undefined) return "";
      return date.split("-").reverse().join("/");
    },
    handleClickCalendar(company, field) {
      this.companyEditDate = { ...company };
      this.fieldEdited = field;
      this.dateDialog = this.dateToEua(company[field]);
      this.modalDate = true;
    },
    handlePickerDate() {
      this.modalDate = false;
      console.log(this.companyEditDate);
      let companySelected = this.companies.findIndex(
        (item) => this.companyEditDate.company_id === item.company_id
      );
      this.companies[companySelected][this.fieldEdited] = this.dateToBr(
        this.dateDialog
      );
      console.log(this.fieldEdited);
      this.fieldEdited = "";
    },
    exportEstimates(type) {
      console.log(type);
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 14px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
#styled-input {
  height: 40px;
  font-size: 20pt;
}
.compact-form .fs-12 {
  transform: scale(0.8);
  transform-origin: left;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
